var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"preguntas-frecuentes"},_vm._l((_vm.preguntas),function(pregunta,i){return _c('div',{key:i,staticClass:"pregunta"},[_c('div',{staticClass:"titulo"},[_vm._v(_vm._s(i + 1)+") "+_vm._s(pregunta.pregunta))]),_c('div',{staticClass:"respuesta",domProps:{"innerHTML":_vm._s(pregunta.resp)}})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }